export const getCurrentUrl = () => window.location.href;
export const redirectToPage = url => {
  window.location.href = url;
};
export const getIsInIframe = () => {
  try {
    return !!window.frameElement;
  } catch (error) {
    return false;
  }
};